// extracted by mini-css-extract-plugin
module.exports = {"product":"_1H8vN","productForFrameless":"_1mJi4","errorMessage":"_3_y76"};